import axios from "axios";

export default {
  data: () => ({
    files: [],
    publication: {
      title: "",
      abstract: "",
      acknowledgements: "",
      keywords: [""],
      isbn: "",
      doi: "",
      authorsrel: [],
      authors_text: "",
      num_authors: 0,
      research_areas: [],
      is_external: false,
      hidden: false,
      featured: false,
      regional: "",
      national: "",
      international: "",
      language: "en",
      minerva_sync_option: null,
      minerva_sync_status: "pending-check",
      minerva_sync_metadata: {},
      minerva_last_checked_at: null,
      links: {
        publisher: "",
        institutional_repository: "",
        personal_repository: "",
        teseo: ""
      },
      best_date: "",
      article: {
        journal: "",
        accepted_date: null,
        online_publication_date: null,
        final_publication_date: null,
        num_pages: null,
        publication_status: "",
        journal_location: {
          issue_number: "",
          volume: "",
          page_number: "",
          pages: ""
        },
        feder_acknowledgements: ""
      },
      communication: {
        congress_edition: "",
        type: "",
        date: "",
        lecture_notes: "",
        prizes: "",
        presented_on_main: false,
        feder_acknowledgements: ""
      },
      bookAndChapter: {
        title: "",
        type: "",
        editorial: "",
        num_pages: "",
        publication_date: "",
        editors: [],
        book_location: {
          chapter: "",
          page_number: "",
          page_start: "",
          page_end: ""
        },
        editors_text: ""
      },
      thesis: {
        doctoral_program: "",
        start_date: "",
        deposit_date: "",
        lecture_date: "",
        read_center: "",
        grade: "",
        international_phd: false,
        tutor: "",
        directors: []
      }
    }
  }),

  methods: {
    loadDefaultAuthor() {
      const path =
        this.$store.state.endpoint +
        "/person/" +
        this.$store.getters.user.person;
      axios
        .get(path)
        .then(response => {
          this.publication.authorsrel.push({
            person: {
              id: response.data.id,
              preferred_name: response.data.preferred_name,
              name_text:
                response.data.preferred_name.given_name +
                " " +
                response.data.preferred_name.family_name
            },
            position: "1"
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    normalizePublicationDefaults(publication) {
      if (!publication) {
        return;
      }
      const set = (obj, key, value) => {
        if (this && typeof this.$set === "function") {
          this.$set(obj, key, value);
        } else {
          obj[key] = value;
        }
      };
      if (publication.hidden === undefined) {
        set(publication, "hidden", false);
      }
      if (publication.featured === undefined) {
        set(publication, "featured", false);
      }
      if (!publication.language) {
        set(publication, "language", "en");
      }
      // minerva_sync_option may remain null
      if (!publication.minerva_sync_status) {
        set(publication, "minerva_sync_status", "pending-check");
      }
      if (!publication.minerva_sync_metadata || typeof publication.minerva_sync_metadata !== "object") {
        set(publication, "minerva_sync_metadata", {});
      }
      if (publication.minerva_last_checked_at === undefined) {
        set(publication, "minerva_last_checked_at", null);
      }
    },

    emitChangeFiles(files) {
      this.files = files
    }
  }
};
